export enum UnitMode {
  Metric = "METRIC",
  Imperial = "IMPERIAL",
}

const MAP: Record<string, UnitMode> = {
  [UnitMode.Metric]: UnitMode.Metric,
  [UnitMode.Imperial]: UnitMode.Imperial,
};

export function getUnitModeFromString(val: string | undefined): UnitMode | undefined {
  return MAP[val ?? ""] ?? undefined;
}
